export default __webpack_public_path__ + "static/media/ACTIVITE_LOISIRS.395ad859.svg";